import React from 'react'

const ListHeader = () => {
  return (
    <div className='w-full'>
    <ul className="flex w-11/12 items-center justify-around ml-14">
        <li>Marka</li>
        <li>Model</li>
        <li>Yil</li>
        <li>Motor</li>
      </ul>
    </div>
  )
}

export default ListHeader